import * as React from 'react';

import { tv } from '@/utils/styles';

const TableCell = React.forwardRef<
  HTMLTableCellElement,
  React.TdHTMLAttributes<HTMLTableCellElement> & {
    focusTooltip?: React.ReactNode;
    hasKeyboardNav?: boolean;
    hasInput?: boolean;
  }
>(({ className, focusTooltip, hasKeyboardNav, hasInput, children, ...props }, ref) => {
  const { base, tooltip } = styles({ hasKeyboardNav });
  return (
    <td ref={ref} className={base({ className })} {...props}>
      {children}
      {Boolean(focusTooltip) && Boolean(hasInput) && <span className={tooltip()}>{focusTooltip}</span>}
    </td>
  );
});

const styles = tv({
  slots: {
    base: 'group relative p-4 py-3 align-middle [&:has([role=checkbox])]:pr-0',
    tooltip:
      'absolute left-0 top-full z-3 hidden rounded-b bg-lightBlue-600 p-2 py-1.5 text-xs leading-none text-white group-focus:block',
  },
  variants: {
    hasKeyboardNav: {
      true: {
        base: 'rounded-none p-4 py-3 align-middle focus-within:shadow-[inset_0_0_0_4px_theme(colors.lightBlue.600)] focus:shadow-[inset_0_0_0_3px_theme(colors.lightBlue.600)] focus:outline-none',
      },
    },
  },
});

TableCell.displayName = 'TableCell';

export { TableCell };
